import Utils from '../../modules/utils'

const getBestSellers = (cadId, callbackFunc) => {
  const url = 'best_sellers/' + cadId
  Utils.get(url, callbackFunc)
}

export {getBestSellers}
